interface UnavailablePartsBody {
  unavailableParts?: { name?: unknown }[];
}

/**
 * Names of the parts a 409 refused because they are no longer active, or null when the
 * error is something else. Shared by the bundle picker and the service parts editor (#3845).
 */
export function unavailablePartNames(error: unknown): string[] | null {
  const status = (error as { status?: unknown } | null)?.status;
  const data = (error as { data?: UnavailablePartsBody } | null)?.data;
  if (status !== 409 || !Array.isArray(data?.unavailableParts)) return null;
  return data.unavailableParts.map((part) => (typeof part.name === 'string' ? part.name : ''));
}
